const env = require('./env.js');

module.exports = () => (
  (env.name === 'Chrome' && env.version > 71) ||
  env.isChromiumEdge ||
  (env.name === 'Opera' && env.version > 58)
);
